import React from 'react'
import { useTranslation } from 'react-i18next'
import Container from '@material-ui/core/Container'
import Alert from '@material-ui/lab/Alert'

const ListNoRecords = () => {
  const { t } = useTranslation()

  return <Container maxWidth="md" style={{ paddingTop: 36 }}>
    <Alert severity="info">{t('noRecords')}</Alert>
  </Container>
}

export default ListNoRecords
